<template>
  <div class="w-full flex justify-between consecutive-widget__header" :class="{ 'is-mobile': $store.getters.isMobile }">
    <div class="flex items-center left-box">
      <span>{{ $t('siteBuild.consecutiveWidget.subtitle') }}:</span>
      <div class="number px-2 py-1">{{ currentNumber }}</div>
    </div>
    <div v-if="minDailyRechargeAmount > 0" class="flex items-center right-box py-1 px-2">
      <span>{{ $t('siteBuild.consecutiveWidget.today') }}</span>
      <div class="flex items-center">
        <template v-if="hasRechargeAmount >= minDailyRechargeAmount">
          <span>{{ $t('siteBuild.done') }}</span>
        </template>
        <template v-else-if="isVirtualCurrency">
          <img :src="virtualCurrencyLogo" class="currency-logo" alt="" />
          <span>{{ hasRechargeAmount }}</span>
          <span class="px-1"> / </span>
          <span>{{ minDailyRechargeAmount }}</span>
        </template>
        <template v-else>
          <span>{{ currencyLabel }}{{ hasRechargeAmount }}</span>
          <span class="px-1"> / </span>
          <span>{{ currencyLabel }}{{ minDailyRechargeAmount }}</span>
        </template>
      </div>
    </div>
    <div v-if="timeoutString" class="flex items-center right-box py-1 px-2">
      <i class="el-icon-timer mr-1 relative" />
      <span class="relative">{{ timeoutString }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    hasRechargeAmount: [Number, String],
    minDailyRechargeAmount: [Number, String],
    rechargeCurrency: [String],
    currentNumber: [String, Number],
    timeoutString: [String],
    activityData: {
      type: Object,
      default() {
        return {}
      }
    },
    currencyType: [Number, String],
    virtualCurrencyLogo: [String]
  },
  computed: {
    isVirtualCurrency() {
      return Number(this.currencyType) === 1 && !!this.virtualCurrencyLogo
    },
    currencyLabel() {
      return this.$store.state.project.currencieMap?.[this.rechargeCurrency]?.label || this.rechargeCurrency
    }
  }
}
</script>

<style lang="less">
.consecutive-widget__header {
  position: relative;
  color: var(--text-color);
  font-size: 18px;
  margin-top: 20px;

  .left-box {
    .number {
      background: var(--countdown-background);
      color: var(--countdown-text-color);
      border-radius: var(--card-radius);
    }
  }

  .right-box {
    background: var(--countdown-background);
    color: var(--countdown-text-color);
    border-radius: var(--card-radius);

    .currency-logo {
      width: 16px;
      height: 16px;
      object-fit: contain;
      margin-right: 2px;
    }
  }

  &.is-mobile {
    font-size: 12px;
    margin-top: 10px;
    padding: 0 5px;
  }
}
</style>
